import { render } from "./TalentTotalPanel.vue?vue&type=template&id=9507381a&scoped=true"
import script from "./TalentTotalPanel.vue?vue&type=script&lang=js"
export * from "./TalentTotalPanel.vue?vue&type=script&lang=js"

import "./TalentTotalPanel.vue?vue&type=style&index=0&id=9507381a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9507381a"]])

export default __exports__